// layouts/snackbar/BlockingSnackBar.tsx
import React, { useEffect } from "react";
import "./BlockingSnackbar.css";
import { useDispatch, useSelector } from "react-redux";

import {
  decrementBlockingCountdown,
  hideBlockingSnackbar,
} from "../../redux/snackbarSlice";
import { RootState } from "../../redux/store";

const BlockingSnackBar: React.FC = () => {
  const dispatch = useDispatch();
  const { isBlockingOpen, blockingCountdown } = useSelector(
    (state: RootState) => state.snackbar
  );

  useEffect(() => {
    if (!isBlockingOpen) return;

    if (blockingCountdown === 0) {
      dispatch(hideBlockingSnackbar());
      window.location.href = "/login"; // redirect after countdown
      return;
    }

    const timer = setTimeout(() => {
      dispatch(decrementBlockingCountdown());
    }, 1000);

    return () => clearTimeout(timer);
  }, [dispatch, blockingCountdown, isBlockingOpen]);

  if (!isBlockingOpen) return null;

  return (
    <div className="blocking-snackbar-overlay">
      <div className="blocking-snackbar">
        <p>
          Session expired. Redirecting to login in {blockingCountdown}{" "}
          seconds...
        </p>
        <button
          className="snackbar-button"
          onClick={() => {
            dispatch(hideBlockingSnackbar());
            window.location.href = "/login";
          }}
        >
          Login
        </button>
      </div>
    </div>
  );
};

export default BlockingSnackBar;
